import React from "react";
import { hatch } from "ldrs";

const ChartLoading = () => {
	hatch.register();

	// Default values shown
	return <l-hatch size="28" stroke="4.5" speed="3.5" color="#eee"></l-hatch>;
};

export default ChartLoading;
